// extracted by mini-css-extract-plugin
module.exports = {"component":"TheTurnTextOverlay_component__V98dz","flashThenFadeTurnTag":"TheTurnTextOverlay_flashThenFadeTurnTag__yeSjZ"};